import React, { useCallback } from 'react';
import { BinXS as BinIcon, IconSize } from '@lux/icons';
import { Translate, Price as Currency } from '@pegasus/translation';
import { Text, Preset } from '@lux/text';
import { FunctionColor } from '@lux/tokens';
import { Size, Price, Image, Title, Header, Content, HeaderText, RemoveItem, Description, CartItemWrapper, StyledPlusBadge, RemoveItemAriaLabel, } from './styles';
export const CartItem = ({ name, size, brand, price, imageUrl, configSku, simpleSku, onItemClick, onItemRemove: onItemRemoveAsync, languageCode, isPlusEnabled, reservationId, plusEarlyAccess, campaignIdentifier, }) => {
    const onItemRemove = useCallback(() => {
        if (!onItemRemoveAsync) {
            return;
        }
        return onItemRemoveAsync(simpleSku);
    }, [simpleSku, onItemRemoveAsync]);
    const handleItemClick = useCallback(() => onItemClick(configSku, campaignIdentifier), [
        configSku,
        campaignIdentifier,
        onItemClick,
    ]);
    return (React.createElement(CartItemWrapper, { role: "group" },
        React.createElement(Header, null,
            React.createElement(HeaderText, { onClick: handleItemClick, href: `/campaigns/${campaignIdentifier}/articles/${configSku}` },
                React.createElement(Text, { preset: Preset.S, color: FunctionColor.function100, bold: true }, brand)),
            React.createElement(RemoveItem, { className: "auto-tests-remove-cart-item", onClick: onItemRemove, "aria-labelledby": `cart-remove-label-${reservationId}` },
                React.createElement(BinIcon, null),
                React.createElement(RemoveItemAriaLabel, { id: `cart-remove-label-${reservationId}` },
                    React.createElement(Translate, { raw: true, message: "removeLabel", params: { name } })))),
        React.createElement(Content, { onClick: handleItemClick, 
            // @TODO consider using the articleUrl property provided by the stockcart api
            href: `/campaigns/${campaignIdentifier}/articles/${configSku}` },
            React.createElement(Image, { src: imageUrl, alt: name }),
            React.createElement(Description, null,
                plusEarlyAccess && isPlusEnabled && (React.createElement(StyledPlusBadge, { size: IconSize.XS, textColor: FunctionColor.function100, backgroundColor: FunctionColor.function0 },
                    React.createElement(Translate, { message: "plusEarlyAccess", raw: true }))),
                React.createElement(Title, null,
                    React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function100 }, name)),
                React.createElement(Size, null,
                    React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function100 },
                        React.createElement(Translate, { message: "size" }),
                        ': '),
                    React.createElement(Text, { preset: Preset.XS, color: FunctionColor.function100 }, size)),
                React.createElement(Price, null,
                    React.createElement(Text, { preset: Preset.S, color: FunctionColor.function100, bold: true },
                        React.createElement(Currency, { cents: String(price), languageCode: languageCode })))))));
};
export default CartItem;
//# sourceMappingURL=index.js.map